import AxiosInstance from "./api";

export const InventorySummaryReportService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/inventory-summary-report", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/inventory-summary-report/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/inventory-summary-report", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/inventory-summary-report/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/inventory-summary-report/${id}`);
  },
};
